import * as React from 'react';

import { PackClassroom, classAssignmentLine, escapeHtml } from './shared';

import { SMALL_ICON_BASE_SRC, Tooltip } from '../../../../Shared/index';

const infoIcon = <img alt="" height="20" src={`${SMALL_ICON_BASE_SRC}/information.svg`} width="20" />

export const ModalInfoNotice = ({ children }: { children: React.ReactNode }) => (
  <div className="modal-info-notice">
    {infoIcon}
    <span>{children}</span>
  </div>
)

export const ClassCountTooltip = ({ classrooms }: { classrooms: PackClassroom[] }) => (
  <Tooltip
    isTabbable={false}
    tooltipText={classrooms.map(classroom => escapeHtml(classAssignmentLine(classroom)))}
    tooltipTriggerText={<span aria-label={`${classrooms.length} classes: ${classrooms.map(classAssignmentLine).join('; ')}`} className="class-count-trigger" role="img">{classrooms.length} classes</span>}
  />
)
